import { MessageType } from 'core/hooks/useIframeMessageListener';
import {
  AstralWalletParentMessage,
  ASTRAL_WALLET_IFRAME_ID,
} from '../constants';

export const astralWalletPostMessageToIframe = (
  message: MessageType<AstralWalletParentMessage>,
) => {
  const iframe = document.getElementById(
    ASTRAL_WALLET_IFRAME_ID,
  ) as HTMLIFrameElement | null;
  iframe?.contentWindow?.postMessage(message, '*');
};
